module.exports = __webpack_public_path__ + "img/max-file-sync--csv.ff3f5ada.svg";